import type { ReactNode } from "react";
import Styles from "./FormGroup.module.scss";

type Props = {
	children: ReactNode;
};

export function FormGroup({ children }: Props) {
	return <div className={Styles.FormGroup}>{children}</div>;
}
